import styled from 'styled-components';
import { H1 } from '@btc-snxt/ui';

export const StyledFaqSettings = styled.div`
  ${H1} {
    display: flex;
    justify-content: center;
  }
`;
